import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Privacy from './pages/Privacy';

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen bg-[#0A0E17] flex flex-col font-sans selection:bg-blue-500/30 selection:text-blue-200">
        <Navbar />
        <main className="flex-grow pt-20">
          <Routes>
            <Route path="/" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HashRouter>
  );
}

export default App;